var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsHybridCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f9c194e4-feb6-45d9-9ef8-50804573cbcd",
    x1: 9,
    y1: 3.889,
    x2: 9,
    y2: 15.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b796f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b962dd2c-4114-42df-be8e-ebf350729bb7",
    x1: 9,
    y1: -0.022,
    x2: 9,
    y2: 9.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b796f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.924,13.008v.229a1.837,1.837,0,1,1-1.848,0v-.211l-6.344.059s-.019,2.506,0,2.607c.1.569.771,1.126,2.009,1.562a18.33,18.33,0,0,0,10.3-.014c1.343-.457,2.086-1.044,2.222-1.638.017-.073.024-2.653.024-2.653Z",
    fill: "#5ea0ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.162,14.8a1.823,1.823,0,0,1,.914-1.565V10.563c-3.6.189-6.371,1.275-6.358,2.56.012,1.186,2.394,2.153,5.587,2.388A1.822,1.822,0,0,1,7.162,14.8Z",
    fill: "#50e6ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.924,10.547v2.69a1.8,1.8,0,0,1,.778,2.244c3.209-.294,5.591-1.313,5.579-2.5C16.269,11.7,13.5,10.673,9.924,10.547Z",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.924,12.543v.694a1.837,1.837,0,1,1-1.848,0v-.693a2.471,2.471,0,1,0,1.848,0Z",
    fill: "#005ba1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16.038a1.232,1.232,0,0,0,1.232-1.233,1.218,1.218,0,0,0-.91-1.169V7.4a1.217,1.217,0,0,0,.914-1.169A1.232,1.232,0,0,0,9,4.994H9A1.232,1.232,0,0,0,7.77,6.225v0A1.218,1.218,0,0,0,8.68,7.4v6.24a1.217,1.217,0,0,0-.914,1.169A1.233,1.233,0,0,0,9,16.038Z",
    fill: "url(#f9c194e4-feb6-45d9-9ef8-50804573cbcd)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.941,3.6A3.694,3.694,0,0,0,9.172.018a3.783,3.783,0,0,0-3.606,2.5A3.5,3.5,0,0,0,2.54,5.929,3.551,3.551,0,0,0,6.178,9.385h1.9V7.8A1.826,1.826,0,0,1,9,4.39H9A1.825,1.825,0,0,1,9.924,7.8V9.385H12.46a3.081,3.081,0,0,0,3-2.934A2.946,2.946,0,0,0,12.941,3.6Z",
    fill: "url(#b962dd2c-4114-42df-be8e-ebf350729bb7)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHybridCloud);
export default __webpack_public_path__ + "static/media/icons-hybrid-cloud.f461dcff81aa1a9c043cdba476a0f315.svg";
export { ForwardRef as ReactComponent };